export default "__VITE_ASSET__C3bOAEHS__"